import { toast } from "react-toastify";
import { Show } from "shared/components";
import { has } from "shared/utils";
import { CancelRerunModal } from "../components/CancelRerunModal";
import { CancelNewIncomeRequestModal } from "../components/CancelNewIncomeRequestModal";
import { RequestIncomeVerificationModal } from "../components/RequestIncomeVerificationModal";
import { EditIncomeModal } from "../components/EditIncomeModal";
import { EditTransactionsModal } from "../components/EditTransactionsModal";
import { RerunIncomeModal } from "../components/RerunIncomeModal";
import { ReverifyIncomeModal } from "../components/ReverifyIncomeModal";
import { VerificationOverrideModal } from "../components/VerificationOverrideModal";
import { useCombinedIncomeContext } from "../providers/useCombinedIncome";

export const ModalsSlice = () => {
  const {
    applicationId,
    applicant,
    currentlySelectedVerificationId,
    settings,
    incomes,
    bankStatements,
    refetch,
    reportModals: {
      showRerunModal,
      setShowRerunModal,
      showCancelRerunModal,
      setShowCancelRerunModal,
      showRequestNewIncomeModal,
      setShowRequestNewIncomeModal,
      showCancelNewIncomeRequestModal,
      setShowCancelNewIncomeRequestModal,
      showReverifyIncomeModal,
      setShowReverifyIncomeModal,
      showEditIncomeModal,
      setShowEditIncomeModal,
      showOverrideVerificationModal,
      setShowOverrideVerificationModal,
      showEditTransactionsModal,
      setShowEditTransactionsModal
    },
    cancelRerun,
    isCancelingRerun,
    cancelNewIncomeRequest,
    isCancelingNewIncomeRequest
  } = useCombinedIncomeContext();

  return (
    <>
      <EditTransactionsModal
        onSuccess={refetch}
        applicationId={Number(applicationId || 0)}
        applicant={applicant}
        verificationId={currentlySelectedVerificationId || 0}
        opened={Boolean(showEditTransactionsModal)}
        onClose={() => setShowEditTransactionsModal(false)}
        allBankStatements={bankStatements}
        {...(typeof showEditTransactionsModal === "object"
          ? showEditTransactionsModal
          : {})}
      />

      <Show if={Boolean(showEditIncomeModal)}>
        <EditIncomeModal
          onSuccess={refetch}
          applicationId={Number(applicationId || 0)}
          applicant={applicant}
          verificationId={currentlySelectedVerificationId || 0}
          opened={Boolean(showEditIncomeModal)}
          onClose={() => setShowEditIncomeModal(false)}
          {...(typeof showEditIncomeModal === "object"
            ? showEditIncomeModal
            : {})}
        />
      </Show>

      <Show if={has(showOverrideVerificationModal)}>
        <VerificationOverrideModal
          onSuccess={() => {
            toast.success("Successfully overrode verification");
            refetch();
            setShowOverrideVerificationModal(false);
          }}
          applicationId={Number(applicationId || 0)}
          applicant={applicant}
          verificationId={currentlySelectedVerificationId || 0}
          opened={Boolean(showOverrideVerificationModal)}
          onClose={() => setShowOverrideVerificationModal(false)}
          {...(typeof showOverrideVerificationModal === "object"
            ? showOverrideVerificationModal
            : {})}
        />
      </Show>

      <Show if={showReverifyIncomeModal}>
        <ReverifyIncomeModal
          onSuccess={() => {
            toast.success("Re-verification requested successfully");
            refetch();
          }}
          settings={settings}
          applicant={applicant}
          applicationId={Number(applicationId || 0)}
          verificationId={currentlySelectedVerificationId || 0}
          opened={has(showReverifyIncomeModal)}
          onClose={() => setShowReverifyIncomeModal(false)}
          income={incomes.find((i) => i.id === showReverifyIncomeModal)}
        />
      </Show>

      <Show if={showRerunModal}>
        <RerunIncomeModal
          opened={showRerunModal}
          onClose={() => setShowRerunModal(false)}
          onSuccess={refetch}
        />
      </Show>

      <Show if={showCancelRerunModal}>
        <CancelRerunModal
          open={showCancelRerunModal}
          onClose={() => setShowCancelRerunModal(false)}
          onConfirm={cancelRerun}
          isPending={isCancelingRerun}
        />
      </Show>

      <Show if={showRequestNewIncomeModal}>
        <RequestIncomeVerificationModal
          opened={showRequestNewIncomeModal}
          onClose={() => setShowRequestNewIncomeModal(false)}
        />
      </Show>

      <Show if={showCancelNewIncomeRequestModal}>
        <CancelNewIncomeRequestModal
          open={showCancelNewIncomeRequestModal}
          onClose={() => setShowCancelNewIncomeRequestModal(false)}
          onConfirm={cancelNewIncomeRequest}
          isPending={isCancelingNewIncomeRequest}
        />
      </Show>
    </>
  );
};
